module.exports = __webpack_public_path__ + "static/img/news_banner.a20176f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_banner.jpg
// module id = iyQ9
// module chunks = 1